import { en, type Messages } from './en';

export const DEFAULT_LOCALE = 'en' as const;

const catalogues: Record<typeof DEFAULT_LOCALE, Messages> = { en };

export const messages = catalogues[DEFAULT_LOCALE];

/**
 * Message accessor. Every user-facing string goes through here so that adding a
 * locale is a change to src/i18n/ and nowhere else.
 */
export function t<K extends keyof Messages>(section: K): Messages[K] {
  return messages[section];
}

export type { Messages };
